module.exports = __webpack_public_path__ + "static/media/5.10043616.png";